import dayjs from "dayjs";

const GeneralService = {
  isAzureUrlValid: ( url ) => {
    if (url === null || url === undefined) return false;
    try {
      const urlParts = url.split("?");
      const queryParams = new URLSearchParams(`?${urlParts[1]}`);
      const se = queryParams.get("se");
      return !dayjs().isAfter(dayjs(se));
    } catch (e) {
      console.error(`GeneralService.isAzureUrlValid() :: ${e.message}`);
      console.info(`url :: ${url}`);
      return false;
    }
  },
  _timeout( ms ) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  async _waitFor( timeoutMs = 0 ) {
    console.log(`GeneralService.async waitFor ${timeoutMs}`);
    await GeneralService._timeout(timeoutMs);
    console.log(`Done`);
    return true;
  }
};

export default GeneralService;



// WEBPACK FOOTER //
// ./src/lib/services/general-service.js